(ns client-portal.client.smart-ordering.sessions.utterances.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.smart-ordering.sessions.data :as so.sessions.d]
            [client-portal.client.voice-insights.sessions.utterances.data :as vi.utterances.d]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def list-path so.sessions.d/utterances-list-path)
(def page-size 100)

(defn page-path [page]
  (conj list-path page))

(defn current-max-page [db]
  (some->> (get-in db list-path)
           (util/when-not-loading)
           (keys)
           (apply max)))

(defn has-more? [db]
  (some->> (get (util/when-not-loading (get-in db list-path)) (current-max-page db))
           (util/when-not-loading)
           (count)
           (<= page-size)))

(re/reg-sub :smart-ordering/utterances-has-more?- has-more?)

(defn list-loading? [db]
  (let [list-data (get-in db list-path)]
    (or (util/loading? list-data) (some-> list-data (get 0) (util/loading?)))))

(re/reg-sub :smart-ordering/utterances-list-loading?- list-loading?)

(defn next-page-loading? [db]
  (let [page (current-max-page db)]
    (and (pos? page) (util/loading? (get-in db (page-path page))))))

(re/reg-sub :smart-ordering/utterances-next-page-loading?- next-page-loading?)

(defn next-page [db]
  (some-> (current-max-page db) (inc)))

(re/reg-sub :smart-ordering/utterances-next-page- next-page)

(re/reg-auth0-loader
  :smart-ordering/load-utterances
  (fn [[[_ {:keys [page]}]] _]
    (page-path (or page 0)))
  (fn [db [_ {:keys [page]} _]]
    (when (and (not (next-page-loading? db))
               (not (list-loading? db))
               (concepts.d/current-concept-id db))
      (let [last-loaded (some-> (util/when-not-loading (get-in db list-path))
                                (get (or (dec (or page 0)) 0))
                                (last))]
        {:method :post
         :url "/api/smart-ordering/utterances/list"
         :json-params (merge (so.sessions.d/base-query-args db {:end-date (:conversation-ts-raw last-loaded)
                                                                :limit page-size})
                             {:end-date-start-ms (:start last-loaded)
                              :end-date-conversation-id (:conversation-id last-loaded)})})))
  :transf vi.utterances.d/transf-utterances-resp
  :error-transf (fn [] []))

(re/reg-sub
  :smart-ordering/utterances-list-
  (fn [db]
    (let [current-list (get-in db list-path)]
      (if (nil? current-list)
        (re/dispatch-load [:smart-ordering/load-utterances [nil {:page 0}]])
        current-list))))

(re/reg-sub
  :smart-ordering/utterances-flattened-
  :<- [:smart-ordering/utterances-list-]
  #(if (or (util/loading? %) (some-> (when (map? %) (util/loading? (get % 0)))))
     :loading
     (so.sessions.d/flattened-list %)))
